<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Pessoa idosa"
            description="Cuidado Integral à pessoa idosa"
            url="/esf-eap"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Pessoa idosa',
    titleTemplate: null,
  },
  data() {
    return {
      linksAjudaPec: [],
      linksAjudaCds: [],
    }
  },
}
</script>

<style></style>
